"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = filterAssets;
var FILTER_VALUES = {
  VIDEO: 'video',
  IMAGE: 'image',
  AUDIO: 'audio',
  OTHER: 'other'
};

function filterAssets(assets) {
  var filterValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!filterValues || !Object.keys(filterValues).length) {
    return assets;
  }

  var hasOtherFilter = filterValues[FILTER_VALUES.OTHER];
  return assets.filter(function (_ref) {
    var metaData = _ref.metaData;

    try {
      var _JSON$parse = JSON.parse(metaData),
          _JSON$parse$type = _JSON$parse.type,
          type = _JSON$parse$type === void 0 ? '' : _JSON$parse$type;

      var assetType = type.split('/')[0];

      if (!assetType) {
        return false;
      }

      return hasOtherFilter ? filterValues[assetType] || ![FILTER_VALUES.VIDEO, FILTER_VALUES.IMAGE, FILTER_VALUES.AUDIO].includes(assetType) : filterValues[assetType];
    } catch (_unused) {
      return false;
    }
  });
}